import { module } from 'modujs';
import { html } from '../utils/environment';
import modularLoad from 'modularload';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 1200,
            transitions: {
                customTransition: {},
                filter: {}
            }
        });

        this.load.on('loading', (transition, oldContainer) => {
            html.classList.remove('has-dom-ready');
            html.classList.remove('has-scrolled');
            html.classList.remove('has-nav-open');
            html.classList.remove('has-filters-stick');
            html.classList.remove('-hide');
            html.classList.remove('has-nav-open-callback');

            html.classList.add('is-loading-callback');

        });

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            html.setAttribute('data-direction', '');
            html.setAttribute('data-theme', newContainer.getAttribute('data-theme'));

            gsap.delayedCall(0.7, () => {
                if(transition == 'filter') {
                    // Scroll to
                    if (window.isMobile) {
                        if (html.classList.contains('has-filters-stick')) {
                            this.call('scrollTo', { target: document.querySelector('.js-filters'), options: { offset: - document.querySelector('.js-header').getBoundingClientRect().height, duration: 0, disableLerp: true } }, 'Scroll');
                        }
                    } else {
                        if(scrollTo) {
                            this.call('scrollTo', { target: document.querySelector('.js-filters'), options: { offset: - document.querySelector('.js-header').getBoundingClientRect().height, duration: 0, disableLerp: true } }, 'Scroll');
                        }
                    }
                }

                html.classList.add('has-dom-ready');

                gsap.delayedCall(0.4, () => {
                    html.classList.remove('is-loading-callback');
                });
            });
        });

        window.addEventListener('modularimages', () => {
            this.call('update', null, 'Scroll')
        })
    }

    goTo(options) {
        const { url, transition } = options;
        this.load.goTo(url, transition);
    }
}
